import { render, staticRenderFns } from "./ClaimSummary.vue?vue&type=template&id=5fbf8783&"
import script from "./ClaimSummary.vue?vue&type=script&lang=ts&"
export * from "./ClaimSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports